/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import moment from 'moment-timezone';

import * as types from './ActionTypes';

export function setCurrentLocation(payload) {
  return {
    type: types.LOCATION_CHANGE,
    payload,
  };
}

export function newAppointment(selectedServices) {
  return (dispatch) => {
    dispatch({
      type: types.APPOINTMENT_NEW,
      payload: selectedServices,
    });
  };
}

export function resetAppointment() {
  return {
    type: types.APPOINTMENT_RESET,
    payload: null,
  };
}

export function nextStep() {
  return {
    type: types.APPOINTMENT_NEXT_STEP,
  };
}

export function updateAppointment(field, value) {
  return {
    type: types.APPOINTMENT_UPDATE,
    payload: { field, value },
  };
}

export function updateAppointmentDate(field, date) {
  return (dispatch, getState) => {
    // The date picker module we use seems to give us the date in the middle of the day
    // while the backend returns the beginning of the day
    const startOfDay = date.startOf('day');
    const allDateSlots = getState().appointment.dateSlots;
    const dateSlot = allDateSlots.find((slot) =>
      startOfDay.isSame(moment(slot.date), 'day'),
    );

    dispatch({
      type: types.APPOINTMENT_UPDATE_DATE_AND_TIMES,
      payload: { date, timeSlots: dateSlot.times },
    });
  };
}

export function nextDateSlot() {
  return {
    type: types.APPOINTMENT_NEXT_DATE_SLOT,
  };
}

export function prevDateSlot() {
  return {
    type: types.APPOINTMENT_PREV_DATE_SLOT,
  };
}
